'use strict';
var app = require('angular').module('auth', []);

app.factory('Authentication', ['Member', 'LoopBackAuth', 'Department', 'myDepartments', 'myTenant', '$q', "$stateParams", require('./authFactory')]);
app.constant('USER_ROLES', require('./authConstant'));
